export enum DeviceServiceType {
  AD_HOC_CONF = 'AD_HOC_CONF',
  CALL_REC = 'CALL_REC',
  DEDICATED_CONF = 'DEDICATED_CONF',
  DESKTOP_CONTROL = 'DESKTOP_CONTROL',
  DESKTOP_OPERATOR = 'DESKTOP_OPERATOR',
  FAX = 'FAX',
  INDICATOR = 'INDICATOR',
  IVR = 'IVR',
  MOBILE = 'MOBILE',
  MOBILE_COMMUNICATOR_WITHOUT_GSM = 'MOBILE_COMMUNICATOR_WITHOUT_GSM',
  MOBILE_CONTROL = 'MOBILE_CONTROL',
  MOBILE_OFFICE = 'MOBILE_OFFICE',
  MOBILE_SLAVE = 'MOBILE_SLAVE',
  PARK_SERV = 'PARK_SERV',
  PREPARATION_MOBILE_SERVICE = 'PREPARATION_MOBILE_SERVICE',
  TABLET = 'TABLET',
  UC_COLLABORATION = 'UC_COLLABORATION',
  UC_COLLABORATION_GUEST = 'UC_COLLABORATION_GUEST',
  UC_COLLABORATION_OWNER = 'UC_COLLABORATION_OWNER',
  UNKNOWN = 'UNKNOWN',
  VOICE_MAIL = 'VOICE_MAIL',
  WEB_CONTROL = 'WEB_CONTROL',
  WEB_WIDGET = 'WEB_WIDGET',
}
